import type { Rate, RateList } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/types'
import unwrapList from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/unwrapList'

const VISIBLE_RATES_LIMIT = 3

/**
 * Отзывы для блока на главной клиники.
 *
 * Берётся `rates` клиники; `ratelpus` — запасной набор, если клиника пустая.
 * Список не режется: карточки после третьей остаются в HTML для SEO
 * и прячутся в списке до «Показать ещё».
 */
export default function getPageRates(
  rates: RateList | undefined,
  ratelpus: RateList | undefined,
): Rate[] {
  const lpuRates = unwrapList(rates)
  const doctorRates = unwrapList(ratelpus)

  return lpuRates.length ? lpuRates : doctorRates
}

export { VISIBLE_RATES_LIMIT }
